import { AfterViewInit, Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatCard } from "@angular/material/card";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput, MatInputModule } from "@angular/material/input";
import { EnrollmentModel } from "../../domain/models/enrollment.model";
import { EnrollmentComponent } from "../enrollment-request/EnrollmentComponent";
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import {FormValidationUtil} from "../../utils/form-validation.util";
import {MatTooltip} from "@angular/material/tooltip";
@Component({
  selector: 'app-mgmt-company-license',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    MatCard,
    MatCheckbox,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatIconModule,
    MatInputModule,
    MatIconModule,
    MatButton,
    MatIcon,
    MatTooltip
  ],
  templateUrl: './mgmt-company-license.component.html',
  styleUrl: './mgmt-company-license.component.css'
})
export class MgmtCompanyLicenseComponent implements AfterViewInit, EnrollmentComponent {
  @Input() enrollment: EnrollmentModel = {};
  licenseForm!: FormGroup;
  constructor(private fb: FormBuilder) {
    this.buildForm({});
  }

  private buildForm(info: EnrollmentModel): void {
    const license = info.entityLicense;
    this.licenseForm = this.fb.group({
      licenseNumber: [license?.regulationLicenseNumber ?? ''],
      taxNumber: [FormValidationUtil.formatTaxCertificateNumber(license?.taxCertificateNumber ?? ''), Validators.required],
      appliedFor: [license?.stateCertificateHasBeenApplied ?? false, Validators.required],
      notRegisteredReason: [license?.reasonWhy ?? '', Validators.required],
      primaryContactEmail: [license?.primaryContactEmail ?? '', [Validators.email, Validators.required]],
      primaryContactFirstName: [license?.primaryContactFirstName ?? '', Validators.required],
      primaryContactLastName: [license?.primaryContactLastName ?? '', Validators.required],
      primaryContactPhoneNumber: [license?.primaryContactPhoneNumber ?? '', [Validators.required,
        Validators.pattern(FormValidationUtil.getPhoneValidationPattern())]],
    });
  }

  onTaxNumberBlur(): void {
    const control = this.licenseForm.get('taxNumber');
    control?.setValue(FormValidationUtil.formatTaxCertificateNumber(control.value ?? ''));
  }

  private conditionalDisabling(): void {
    const taxNumberControl = this.licenseForm.get('taxNumber');
    const appliedForControl = this.licenseForm.get('appliedFor');
    const notRegisteredReasonControl = this.licenseForm.get('notRegisteredReason');

    if(taxNumberControl?.value){
      taxNumberControl?.enable();
      appliedForControl?.disable();
      notRegisteredReasonControl?.disable();
    } else if(notRegisteredReasonControl?.value){
      notRegisteredReasonControl?.enable();
      appliedForControl?.disable();
      taxNumberControl?.disable();
    } else if(appliedForControl?.value){
      appliedForControl?.enable();
      notRegisteredReasonControl?.disable();
      taxNumberControl?.disable();
    } else {
      taxNumberControl?.enable();
      notRegisteredReasonControl?.enable();
      appliedForControl?.enable();
    }
  }

  getUpdatedEnrollment(): EnrollmentModel {
    const formValues = this.licenseForm.value;
    return {
      enrollmentRentalPropertyLicense: {
        regulationLicenseNumber: formValues.licenseNumber,
        taxCertificateNumber: formValues.taxNumber,
        stateCertificateHasBeenApplied: formValues.appliedFor,
        reasonWhy: formValues.notRegisteredReason
      },
      primaryContactEmail: formValues.primaryContactEmail,
      primaryContactFirstName: formValues.primaryContactFirstName,
      primaryContactLastName: formValues.primaryContactLastName,
      primaryContactPhoneNumber: formValues.primaryContactPhoneNumber
    };
  }

  ngAfterViewInit(): void {
    this.buildForm(this.enrollment);
    this.conditionalDisabling();
  }

  isFormValid(): boolean {
    this.conditionalDisabling();
    return this.licenseForm.valid;
  }

  raiseFormValidations(): void {
    this.licenseForm.markAllAsTouched();
  }
  getForm() {
    return this.licenseForm;
  }


}
